"use strict";
// packages/types/src/incomingGoods.ts
Object.defineProperty(exports, "__esModule", { value: true });
